import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "w100 whitesmoke",
  style: {}
}
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`AvailableTimeContent`)
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "fs11 grey fr",
  style: {"margin-top":"3px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { innerHTML: `</form>` }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, " お問い合わせいただき、ありがとうございました。 具体的なご相談のお時間を以下の予定から、日程を確定することも可能です。 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "カレンダー表示", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://docs.google.com/forms/d/e/1FAIpQLSclR33xm-EFQCb54YgrZVmbAv43MnVJRlZlxZKy2Hj6q2oj_Q/viewform?embedded=true",
    width: "640",
    height: "812",
    frameborder: "0",
    marginheight: "0",
    marginwidth: "0"
  }, "読み込んでいます…")
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_LinkHeader = _resolveComponent("LinkHeader")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createVNode(_component_LinkHeader, {
      pageTitle: `フォームを生成`,
      buttonTitle: ``,
      buttonEnabled: false,
      onClickPinkButton: _ctx.publishEmbedsUrl,
      showBackButton: true
    }, null, 8, ["onClickPinkButton"]),
    (_ctx.form)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_ctx.isSP ? `RoomSettingsContentWhite` : `w80 ml15`} fl with_white_bg`),
            style: {"margin-top":"100px","padding":"20px"}
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.fields, (field, fieldindex) => {
              return (_openBlock(), _createElementBlock("p", { key: fieldindex }, _toDisplayString(field), 1))
            }), 128)),
            _hoisted_3,
            _hoisted_4,
            _createTextVNode(" form: " + _toDisplayString(_ctx.form.form_info) + " ", 1),
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" submit_button: " + _toDisplayString(_ctx.form.submit_button_info), 1)
          ], 2),
          _hoisted_7,
          (!_ctx.sentForm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`${_ctx.isSP ? `RoomSettingsContentWhite` : `w80 ml15`} fl with_white_bg`),
                style: {"margin-top":"50px","padding":"20px"}
              }, [
                _createElementVNode("div", {
                  innerHTML: _ctx.form.html,
                  ref: "primaryForm"
                }, null, 8, _hoisted_8),
                _createElementVNode("div", {
                  class: _normalizeClass(`${_ctx.form.submit_button_info[`class`]}`),
                  style: {"padding":"5px 20px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendForm && _ctx.sendForm(...args)))
                }, "送信", 2),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_MdProgressSpinner, { width: "12" })
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_10
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(`${_ctx.isSP ? `RoomSettingsContentWhite` : `w80 ml15`} fl with_white_bg`),
                style: {"margin-top":"50px","padding":"20px"}
              }, _hoisted_13, 2)),
          _hoisted_14,
          _createElementVNode("div", null, [
            _createTextVNode(" html_from "),
            _createElementVNode("div", {
              style: {"display":"none"},
              innerHTML: _ctx.form.html_from
            }, null, 8, _hoisted_15)
          ]),
          _hoisted_16,
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}